/*  MUI  */
import { Typography } from '@mui/material';

/*  Shared  */
import { Token } from 'application/Shared/Requests';

/* Hooks */
import { getUserTheme } from 'hooks/dataAccess/User/userTheme';

/*  React  */
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';

/*  Components  */
import { IntegrationWrapper } from './Components/IntegrationWrapper';

/* Constants */
import IntegrationScriptFilename from './Constants/IntegrationScriptsFilename.json';

/* Helpers */
import { getScript } from './Helpers/utils';

class NinjaOne extends Component {
    constructor(props) {
        super(props);
        this.state = {
            deploymentSteps: [],
            hasToken: false
        };

        /* requests */
        this.Token = new Token();
    }

    componentDidMount() {
        this.load();
    }

    componentWillUnmount() {
        this.unload();
    }

    load = async () => {
        const partnerToken = await this.Token.getToken();

        if (partnerToken) {
            this.setState({ hasToken: true });
            this.setDeploymentSteps(partnerToken);
        }
    };

    unload = () => {
        this.unmount = true;
        this.Token.cancel();
    };

    setDeploymentSteps = async (token) => {
        if (this.unmount) {
            return;
        }

        const { t } = this.props;

        const scriptCopyValue = await getScript({
            filename: IntegrationScriptFilename.ninjaOneScript,
            token
        });

        const deploymentSteps = [
            {
                component: (
                    <Typography variant="h4">
                        {t('Integrations.setup_process')}
                    </Typography>
                ),
                step: false
            },
            {
                component: t('Integrations.Ninja.step1'),
                step: true
            },
            {
                component: (
                    <Typography
                        dangerouslySetInnerHTML={{
                            __html: t('Integrations.Ninja.step2')
                        }}
                    />
                ),
                step: true
            },
            {
                component: (
                    <Typography
                        dangerouslySetInnerHTML={{
                            __html: t('Integrations.Ninja.step3')
                        }}
                    />
                ),
                step: true
            },
            {
                component: t('Integrations.Ninja.step4'),
                copyValue: scriptCopyValue,
                step: true
            },
            {
                component: (
                    <Typography
                        dangerouslySetInnerHTML={{
                            __html: t('Integrations.Ninja.step5')
                        }}
                    />
                ),
                step: true
            },
            {
                component: (
                    <Typography
                        dangerouslySetInnerHTML={{
                            __html: t('Integrations.Ninja.step6')
                        }}
                    />
                ),
                step: true
            }
        ];

        if (!this.unmount) {
            this.setState({ deploymentSteps });
        }
    };

    render() {
        const { onboarding = false, session, t } = this.props;
        const { deploymentSteps, hasToken } = this.state;
        const userTheme = getUserTheme(session?.user?.theme);

        return (
            <IntegrationWrapper
                hasToken={hasToken}
                deploymentSteps={deploymentSteps}
                headerTitle={t('Integrations.ninja')}
                img={`/images/${userTheme}/integrations/ninja_one.png`}
                imgWidth="200px"
                onboarding={onboarding}
            />
        );
    }
}
export default withTranslation()(NinjaOne);
